import { ReactNode } from "react";
import tw from "src/utils/tw";

interface Props {
  removeItem?: () => void;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function EnabledOfferingItem(props: Props) {
  function removeItem() {
    props.removeItem();
  }

  return (
    <div
      className={tw(
        "mb-4 flex rounded border border-borderGray",
        props.className
      )}
    >
      <div className="flex-1 px-4 py-4" onClick={props.onClick}>
        {props.children}
      </div>

      {props.removeItem && (
        <div>
          <button className="cursor-pointer p-4" onClick={removeItem}>
            <i aria-hidden className="far fa-circle-xmark text-empty" />
          </button>
        </div>
      )}
    </div>
  );
}
